import type { JSX, ReactNode } from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

// implement the default behavior from styled-components v5 in order to support
// non-transient props on styled components
const shouldForwardProp = (propName: string, target: unknown): boolean => {
  if (typeof target === 'string') {
    // for HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // for other elements, forward all props
  return true;
};

type StyledComponentsCompatibilityProviderProps = {
  children: ReactNode;
};

export const StyledComponentsCompatibilityProvider = ({
  children,
}: StyledComponentsCompatibilityProviderProps): JSX.Element => {
  return (
    <StyleSheetManager
      enableVendorPrefixes={true}
      shouldForwardProp={shouldForwardProp}
    >
      {children}
    </StyleSheetManager>
  );
};
